import { render, staticRenderFns } from "./noAuth.vue?vue&type=template&id=5c01c83b&scoped=true"
import script from "./noAuth.vue?vue&type=script&lang=js"
export * from "./noAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c01c83b",
  null
  
)

export default component.exports